import { render, staticRenderFns } from "./ManageEventsModal.vue?vue&type=template&id=6c1fc040&scoped=true&"
import script from "./ManageEventsModal.vue?vue&type=script&lang=ts&"
export * from "./ManageEventsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ManageEventsModal.vue?vue&type=style&index=0&id=6c1fc040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1fc040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VDialog,VIcon})
